import { Env } from 'types';

export const env = process.env as Readonly<Env>;
